import { render, staticRenderFns } from "./ButtonHistory.vue?vue&type=template&id=1e13fd20&"
import script from "./ButtonHistory.vue?vue&type=script&lang=ts&"
export * from "./ButtonHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports